/* jshint browser: true */
// IE polyfill for NodeList.forEach
"use strict"
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, argument) {
        argument = argument || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(argument, this[i], i, this);
        }
    };
}

function offset(el) {
    let rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft
    }
}

function nav(header, headerHeight) {

    let body = document.body;
    body.style.paddingTop = headerHeight + 'px';

    window.addEventListener('scroll', function () {
        let position = window.pageYOffset;

        if (position > 120) {
            header.classList.add('fixed');
        } else {
            //     body.style.paddingTop = 0;
            header.classList.remove('fixed');
        }
    });
}

function isMobile() {
    let menuToggle = document.getElementById('menu-toggle');
    let isMobileMenu = window.getComputedStyle(menuToggle).display == 'block';

    return isMobileMenu;
}

function scrollSpy(scrollOffset) {

    let section = document.querySelectorAll(".scrollspy");
    let sections = {};
    let i = 0;

    Array.prototype.forEach.call(section, function (e) {
        sections[e.id] = offset(e).top;
    });

    window.addEventListener('scroll', function () {
        let scrollPosition = (document.documentElement.scrollTop || document.body.scrollTop) + scrollOffset + 1;
        let activeLink;
        for (i in sections) {
            if (sections[i] <= scrollPosition) {
                activeLink = document.querySelector('#nav a.active');

                if (activeLink) {
                    activeLink.setAttribute('class', ' ');
                }

                document.querySelector('#nav a[href*=' + i + ']').setAttribute('class', 'active');
            }
        }
    });
}

function closeModal(modal) {
    modal.classList.remove('visible');
    document.body.classList.remove('modal-opened');
}

function openModal(modal) {
    modal.classList.add('visible');
    document.body.classList.add('modal-opened');
}

function addEvent(element, evnt, funct){
  if (element.attachEvent)
   return element.attachEvent('on'+evnt, funct);
  else
   return element.addEventListener(evnt, funct, false);
}

// example

function modals() {

    var modal = document.getElementById('offer-modal');

    var modalContent = $('#offer-modal #modal-content');
    var ajaxLoader = $('#offer-modal .ajax-loader');
    var body = $('body');

    body.on("click", '#offer-modal #close-modal', function () {
        closeModal(modal);
        modalContent.html('');
    });

    body.on("click",'a[data-target="#offer-modal"]' , function()  {
        var urlReplace = "#" + $(this).attr('data-href');
        history.pushState(null, null, urlReplace);
        var post = $(this).attr('data-post');
        openModal(modal);

        ajaxLoader.show();

        $.ajax({
            type: "POST",
            url: "../../../wp-admin/admin-ajax.php",
            dataType: 'html',
            data: ({ action: 'displayPost', post: post}),

            success: function (data) {
                modalContent.html(data);
                modalContent.addClass('visible');
                modalContent.addClass('in');
                post = null;
                ajaxLoader.hide();
            },
            error: function(data)
            {
                alert("Your browser broke!");
                return false;
            }
        });
    });
    body.on("click",'button[data-type="switch-project"]' , function()  {
        var urlReplace = "#" + $(this).attr('data-href');
        history.pushState(null, null, urlReplace);

        var direction = $(this).attr('data-direction');

        modalContent.removeClass('slideFromRight');
        modalContent.removeClass('slideFromLeft');
        modalContent.removeClass('in');
        ajaxLoader.show();

        modalContent.addClass('switchMode');
        if (direction == 'next') {
            modalContent.addClass('slideToLeft');
        }
        if (direction == 'prev') {
            modalContent.addClass('slideToRight');
        }
        var post = $(this).attr('data-target-post');
        $.ajax({
            type: "POST",

            // url: "/wp-content/themes/Admar/plugins/ajax.php",
            url: "../../../wp-admin/admin-ajax.php",
            dataType: 'html',
            data: ({ action: 'displayPost', post: post}),

            success: function(data){

                if (direction == 'next') {
                    modalContent.removeClass('slideToLeft');
                    modalContent.addClass('shiftRight');
                }

                if (direction == 'prev') {
                    modalContent.removeClass('slideToRight');
                    modalContent.addClass('shiftLeft');
                }

                modalContent.html(data);

                ajaxLoader.hide();

                if (direction == 'next') {
                    setTimeout(function(){
                        modalContent.addClass('slideFromRight');
                        modalContent.removeClass('shiftRight');
                    }, 10);
                }

                if (direction == 'prev') {
                    setTimeout(function(){
                        modalContent.addClass('slideFromLeft');
                        modalContent.removeClass('shiftLeft');
                    }, 10);
                }
                setTimeout(function(){
                    modalContent.addClass('in');
                }, 800);

                post = null;

            },
            error: function(data)
            {
                alert("Your browser broke!");
                return false;
            }

        });
            // $('#offer-modal .modal-content').attr('class', 'modal-content visible switchMode');
    });

    if (window.location.hash) {
        var target = $('a[href="' + window.location.hash + '"]');
        if (target.length) {
            target[0].click();
        }
    }


}

(function ($) {
    //detect "scroll down" href
    let body = document.body;
    let header = document.getElementById('header');
    let headerHeight = header.getBoundingClientRect().height;
    let scrollOffset = headerHeight;

    if (!isMobile()) {
        scrollOffset = 66;
    }

    let scroll = new SmoothScroll('a[href*="#"]:not(.no-scroll)', {
        speed: 500,
        offset: scrollOffset,
        easing: 'easeInOutQuad'
    });
    modals();

    window.addEventListener('load', function () {
        nav(header, headerHeight);
        scrollSpy(scrollOffset);
    });

    function contactFormFocus(el) {
        if ($.trim(el.val()).length > 0) {
            el.parents('.form-field').addClass('active');
        } else {
            el.parents('.form-field').removeClass('active');
        }
    }

    $('#menu-toggle').click(function () {
        $('#nav').slideToggle();
    });

    $('.form-wrap input:not([type="file"]), .form-wrap textarea')
    .each(function () {
        contactFormFocus($(this));
    })
    .focus(function () {
        $(this).parents('.form-field').addClass("active");
    })
    .blur(function () {
        contactFormFocus($(this));
});
})(jQuery);
